import ResultsFormatterBase from "../../formatters/ResultsFormatterBase.js";
import {
    HitData, ResultData, ResultType, QualityOfContact, HitReprocessed, ResultDataNew, DataSection,
} from "../../enums/index.js";
import QualityOfContactEstimator from '../../converters/QualityOfContactEstimator.js';
import ResultPair from "../../valueObjects/ResultPair.js";

// see https://docs.google.com/document/d/1Vy6RyhEqXyqW0_5aKtMIs9jwaPFw6jztjZNUkVY_VRc/edit#heading=h.3is52rp9dyww
// https://www.mlb.com/news/new-statcast-metric-barrels-has-best-hit-balls-c201699298
class QualityOfContactFormatter extends ResultsFormatterBase {
    constructor(qualityOfContactEstimator, newStructure) {
        super();

        if (typeof(qualityOfContactEstimator) === 'undefined') {
            this.qualityOfContactEstimator = new QualityOfContactEstimator();
        }
        else if (!(qualityOfContactEstimator instanceof QualityOfContactEstimator)) {
            throw new TypeError('qualityOfContactEstimator must be an instance inheriting from QualityOfContactEstimator or undefined in order to use default implmentation');
        }
        else {
            this.qualityOfContactEstimator = qualityOfContactEstimator;
        }

        if (typeof(newStructure) === 'undefined') {
            this.newStructure = false;
        }
        else if(typeof(newStructure) === 'boolean') {
            this.newStructure = newStructure;
        }
        else {
            throw new TypeError('newStructure must be boolean or undefined');
        }
    }

    format(results) {
        const dataKey = this.newStructure ? ResultDataNew.Data.key : ResultData.Data.key;
        const typeKey = this.newStructure ? ResultDataNew.Type.key : ResultData.Type.key;

        for (let i = 0; i < results.length; i++) {
            let result = results[i];

            if (!result || !result[dataKey]) {
                continue;
            }

            if (!ResultType.hasHit(result[typeKey])) {
                continue;
            }

            if (!result.hasOwnProperty(dataKey) || !result[dataKey]) {
                continue;
            }

            if (this.newStructure) {
                // prefer tagging data
                let qoc = QualityOfContact.Unidentified.key;
                if (
                    result[dataKey][DataSection.Tagging.key]
                    && result[dataKey][DataSection.Tagging.key][ResultPair.getHitProperty()]
                    && result[dataKey][DataSection.Sensor.key]
                    && result[dataKey][DataSection.Sensor.key][ResultPair.getHitProperty()]
                ) {
                    result[dataKey][DataSection.Tagging.key][ResultPair.getHitProperty()][HitReprocessed.QualityOfContactR.key] = QualityOfContact.Unidentified.key;
                    const verticalLaunch = result[dataKey][DataSection.Sensor.key][ResultPair.getHitProperty()][HitData.LaunchV.key];
                    const exitSpeed = result[dataKey][DataSection.Sensor.key][ResultPair.getHitProperty()][HitData.ExitSpeed.key];
                    if (exitSpeed < 0 || typeof(exitSpeed) !== 'number') {
                        continue;
                    }
                    if (typeof(verticalLaunch) !== 'number') {
                        continue;
                    }

                    result[dataKey][DataSection.Tagging.key][ResultPair.getHitProperty()][HitReprocessed.QualityOfContactR.key] = this.determineQualityOfContact(verticalLaunch, exitSpeed);
                }
            }
            else {
                result[dataKey][HitReprocessed.QualityOfContactR.key] = QualityOfContact.Unidentified.key;

                const verticalLaunch = result[dataKey][HitData.LaunchV.key];
                const exitSpeed = result[dataKey][HitData.ExitSpeed.key];
                if (exitSpeed < 0 || typeof(exitSpeed) !== 'number') {
                    continue;
                }
                if (typeof(verticalLaunch) !== 'number') {
                    continue;
                }

                result[dataKey][HitReprocessed.QualityOfContactR.key] = this.determineQualityOfContact(verticalLaunch, exitSpeed);
            }
        }

        return results;
    }

    determineQualityOfContact(verticalLaunchAngle, exitSpeed){
        return this.qualityOfContactEstimator.estimate(verticalLaunchAngle, exitSpeed);
    }
};

export default QualityOfContactFormatter;